<div class="row m-2">
  <mat-form-field appearance="outline" class="col-md-4">
    <mat-label>Session Type</mat-label>
    <mat-select [(ngModel)]="sessionType">
      <mat-option value="Rapport Building">Rapport Building</mat-option>
      <mat-option value="Baseline Assessment">Baseline Assessment</mat-option>
      <mat-option value="Regular Study">Regular Study</mat-option>
      <mat-option value="Intermediate Assessment">Intermediate Assessment</mat-option>
      <mat-option value="Discharge Assessment">Discharge Assessment</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
    <mat-label>Center Name</mat-label>
    <mat-select [(ngModel)]="selectedCentre" >
      <mat-option *ngFor="let c of (centres$ | async)"
                  [value]="c">{{c.centreName}}</mat-option>
    </mat-select>

  </mat-form-field>

<!--  <mat-form-field appearance="outline" class="col-md-4">-->
<!--    <mat-label>Education session conducted by teacher</mat-label>-->
<!--    <mat-select [(ngModel)]="conductedBy">-->
<!--      <mat-option value="c">c</mat-option>-->
<!--    </mat-select>-->
<!--  </mat-form-field>-->

  <mat-form-field appearance="outline" class="col-md-4">
    <mat-label>From</mat-label>
    <input matInput [matDatepicker]="startDatePicker" [ngModel]="startDate" >
    <mat-hint>DD/MM/YYYY</mat-hint>
    <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #startDatePicker></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-md-4">
    <mat-label>To</mat-label>
    <input matInput [matDatepicker]="endDatePicker" [(ngModel)]="endDate" readonly>
    <mat-hint>DD/MM/YYYY</mat-hint>
    <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #endDatePicker></mat-datepicker>
  </mat-form-field>

  <div class="row">

    <mat-form-field appearance="legacy" class="col-md-6">
      <mat-label><span class="bi bi-search me-2"></span>Select Name</mat-label>
      <input matInput  (input)="applyFilter($event)" placeholder="Select Name" #input>
    </mat-form-field>

    <div class="col-md-6 text-end ">
      &nbsp;&nbsp;<button mat-mini-fab color="accent"  matTooltip="Search" (click)="Search()">
      <mat-icon>search</mat-icon>
    </button>&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;   <button mat-mini-fab color="accent"  (click)="clearAll()" matTooltip="Clear">
      <mat-icon>clear</mat-icon>

    </button>
    </div>

  </div>
</div>

<div>
  <section>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <!-- Position Column -->
      <ng-container matColumnDef="position">
        <th mat-header-cell *matHeaderCellDef> No. </th>
        <td mat-cell *matCellDef="let element"> {{element.position}} </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="childName">
        <th mat-header-cell *matHeaderCellDef>Name </th>
        <td mat-cell *matCellDef="let element">{{getChildrenString(element.children)}} </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="centre">
        <th mat-header-cell *matHeaderCellDef> Centre </th>
        <td mat-cell *matCellDef="let element">{{getCentresString(element.centres)}} </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef> Date</th>
        <td mat-cell *matCellDef="let element"> {{(element.sessionDate).toDate() | date : 'dd/MM/yyyy'}} </td>
      </ng-container>

      <ng-container matColumnDef="timing">
        <th mat-header-cell *matHeaderCellDef>Timing</th>
        <td mat-cell *matCellDef="let element">{{getTime(element.startTime)}}  </td>
      </ng-container>
      <ng-container matColumnDef="type_session">
        <th mat-header-cell *matHeaderCellDef>Type of Session</th>
        <td mat-cell *matCellDef="let element">{{element.sessionType}}  </td>
      </ng-container>
      <ng-container matColumnDef="subject">
        <th mat-header-cell *matHeaderCellDef>Subject</th>
        <td mat-cell *matCellDef="let element"> {{element.subject}} </td>
      </ng-container>
      <ng-container matColumnDef="topic_covered">
        <th mat-header-cell *matHeaderCellDef>Topic Covered</th>
        <td mat-cell *matCellDef="let element"> {{element.topicsCovered}} </td>
      </ng-container>
      <ng-container matColumnDef="session">
        <th mat-header-cell *matHeaderCellDef>Session</th>
        <td mat-cell *matCellDef="let element">  </td>
      </ng-container>
      <ng-container matColumnDef="remark">
        <th mat-header-cell *matHeaderCellDef>Remark</th>
        <td mat-cell *matCellDef="let element"> {{element.remark}} </td>
      </ng-container>
      <ng-container matColumnDef="teacher">
        <th mat-header-cell *matHeaderCellDef>Teacher</th>
        <td mat-cell *matCellDef="let element">{{element.submittedBy}}  </td>
      </ng-container>
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef> Created At </th>
        <td mat-cell *matCellDef="let element"> <span *ngIf='element.createdAt' >{{getDateandTime(element?.createdAt)}}</span> </td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button color="accent" (click)="viewDialog(element)" matTooltip="View"><mat-icon>remove_red_eye</mat-icon></button>


        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[25, 50, 75, 100,200]" aria-label="Select page of users"></mat-paginator>
  </section>
</div>
